export const PlansEndpoints = Object.freeze({
  List: '/v3/plans/gateways',
  PlanDetails: '/v3/plans/details',
  PaymentZarinpal: '/v3/payments/purchasePlan/zarinpal',
  PaymentTrial: '/v3/payments/trial',
  TrialStatus: '/v3/plans/trial'
})
